import React, { ReactNode } from 'react'
import styles from './FieldWrapper.module.css'
import { SortDirection, SortIcon } from '../../icons/SortIcon/SortIcon'


interface Props {
  label: string
  children?: ReactNode
  className?: string
  topChildren?: ReactNode
  error?: string

  sortKey?: string
  activeSortField?: string
  sortOrder?: SortDirection
  onSortChange?: (field: string, direction: SortDirection) => void
}

export const FieldWrapper: React.FC<Props> = ({
  label,
  className,
  topChildren,
  children,
  error,
  sortKey,
  activeSortField,
  sortOrder,
  onSortChange,
}) => {
  const isSortable = Boolean(sortKey && onSortChange)
  const isActive = isSortable && activeSortField === sortKey

  const handleClick = () => {
    if (!isSortable || !sortKey) return

    const nextDirection: SortDirection =
      isActive && sortOrder === 'ASC' ? 'DESC' : 'ASC'

    onSortChange?.(sortKey, nextDirection)
  }

  return (
    <div className={`${styles.wrapper} ${className ?? ''}`}>
      <div
        className={styles.header}
        onClick={isSortable ? handleClick : undefined}
      >
        <p className={`${styles.title} ${error ? styles.titleError : ''}`}>{label}</p>

        {topChildren}

        {isSortable && (
          <SortIcon
            active={isActive}
            direction={isActive ? sortOrder : undefined}
          />
        )}
      </div>

      {children}
    </div>
  )
}